import { useState, useEffect, useMemo } from 'react';
import { groupsService } from 'services';
// Nota: En el futuro importaremos useQuery de react-query
// import { useQuery } from 'react-query';
// import { getAllGroups } from 'api/groups';

/**
 * Hook para cargar y gestionar la lista de grupos
 * Este hook reutiliza las acciones existentes y será preparado para migrar a react-query
 */
export default function useGroupList() {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  
  useEffect(() => {
    const loadGroups = async () => {
      setLoading(true);
      try {
        const response = await groupsService.getAll();
        if (response.ok) {
          setGroups(response.data);
          setError(null);
        } else {
          setError('Error al cargar los grupos');
        }
      } catch (err) {
        setError('Error al cargar los grupos');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    
    loadGroups();
  }, []);
  
  // Lista filtrada de grupos basada en el término de búsqueda
  const filteredGroups = useMemo(() => {
    if (!searchTerm) return groups;
    
    return groups.filter(group => {
      const nameLower = group.name.toLowerCase();
      const searchLower = searchTerm.toLowerCase();
      return nameLower.includes(searchLower);
    });
  }, [groups, searchTerm]);
  
  const handleSearch = (term) => {
    setSearchTerm(term);
  };
  
  return {
    groups: filteredGroups,
    loading,
    error,
    searchTerm,
    handleSearch
  };
}